import { NeatConfig } from '@firecms/neat';

export const DATE_FORMAT = 'EEE, dd MMM, yyyy hh:mm a';

export const NEAT_BACKGROUND_CONFIGS: NeatConfig = {
  colors: [
    { color: '#BAE8E3', enabled: true },
    { color: '#D6D3E6', enabled: true },
    { color: '#D6E0D6', enabled: true },
    { color: '#C1E4F4', enabled: true },
    { color: '#D6CDE9', enabled: true },
  ],
  speed: 4.5,
  horizontalPressure: 3,
  verticalPressure: 3,
  waveFrequencyX: 0,
  waveFrequencyY: 0,
  waveAmplitude: 0,
  shadows: 1,
  highlights: 4,
  colorBrightness: 1,
  colorSaturation: 8,
  wireframe: false,
  colorBlending: 2,
  backgroundColor: '#FF0000',
  backgroundAlpha: 1,
  grainScale: 0,
  grainSparsity: 0,
  grainIntensity: 0,
  grainSpeed: 0,
  resolution: 0.5,
  yOffset: 664,
};
